import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EfBanner from '@elem/ui/ef-banner';
import EfVideo from '@elem/ui/ef-video';
import { FC, useEffect, useRef, useState } from 'react';
import NavCommon from '../../FY2024/Teaser/NavCommon';
import Subscribe from '../Sections/Subscribe';
import ActivityPreview from '../Sections/ActivityPreview';
import Energy from '../Sections/Energy';
import Footer from '../Sections/Footer';
import Introduction, { IntroductionHandle } from '../Sections/Introduction';
import JoinNow from '../Sections/JoinNow';
import PointsTask from '../Sections/PointsTask';
import Product from '../Sections/Product';
import Referral from '../Sections/Referral';
import TimeLine from '../Sections/TimeLine';
import UGC from '../Sections/UGC';
import WelfareCenter from '../Sections/WelfareCenter';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { youtubeMap } from '../constants';

const TeaserCompoment: FC = ({}) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday');
    const introductionRef = useRef<IntroductionHandle>(null);
    const [isEnter, setIsEnter] = useState(false);
    const [startPlay, setStartPlay] = useState(false);
    const youtubeUrl = youtubeMap[locale] || youtubeMap.us;

    const defaultList: any[] = [
        {
            title: t('membersdaynav25.membersdaynav_item1'),
            href: 'power-share',
        },
        {
            title: t('membersdaynav25.membersdaynav_item2'),
            href: 'energy',
        },
        {
            title: t('membersdaynav25.membersdaynav_item3'),
            href: 'introduction',
        },
        {
            title: t('membersdaynav25.membersdaynav_item4'),
            href: 'referral',
        },
        {
            title: t('membersdaynav25.membersdaynav_item5'),
            href: 'UGC',
        },
        // {
        //     title: t('membersdaynav25.membersdaynav_item6'),
        //     href: 'teaser-ActivityPreview',
        // },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneA = AniContainer.create({
                asyncFromTo: [[`.${styled.teaser} .ef-banner .ef-img`, { opacity: 1 }, { opacity: 0 }, 1]],
                triggerElement: `.${styled.teaser} .ef-banner`,
                triggerHook: 1,
                offset: '10%',
                duration: '100%',
            });

            const sceneB = AniContainer.create({
                // asyncFromTo: [
                //     [`.${styled.teaser} .ani-box .video`, { opacity: 0 }, { opacity: 1 }, 1],
                //     [`.${styled.teaser} .ani-box .ani-text`, { opacity: 0, scale: 1 }, { opacity: 1, scale: 1.5 }, 1],
                //     [`.${styled.teaser} .ani-box .ani-text`, { opacity: 1, scale: 1.5 }, { opacity: 0, scale: 1.5 }, 1],
                //     [`.${styled.teaser} .ani-box .energy-box`, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 1],
                //     [`.${styled.teaser} .ani-box .energy-tools`, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 1],
                //     [`.${styled.teaser} .ani-box .task-list`, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 1],
                // ],
                triggerElement: `.${styled.teaser} .ani-box`,
                // asyncTimeLine: [0, 1, 2, 3, 3, 3],
                triggerHook: 1,
                offset: '90%',
                duration: '100%',
                onEnter: () => {
                    setIsEnter(true);
                    setStartPlay(true);
                },
            });
            AniContainer.scrollHandle(); //执行一次初始化
            return () => AniContainer.removeScene([sceneA, sceneB]);
        }
    }, []);

    return (
        <div className={styled.teaser}>
            <EfBanner
                className="member-banner-2025"
                title={t('membersdaybanner25.banner25_title')}
                subTitle={t('membersdaybanner25.banner25_subtitle')}
                desc={t('membersdaybanner25.banner25_desc')}
                theme="white"
                pc="https://websiteoss.ecoflow.com/upload/image/1742611910081/kv_membersday.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1742815064355/mobile-kv.jpg"
                btn_text={t('membersdaybanner25.banner25_btn')}
                btn_link={youtubeUrl}
                // bottomChildren={<TimeLine />}
            />
            {/* 导航 */}
            <NavCommon list={defaultList} />
            {/* 福利中心 */}
            <WelfareCenter />
            {/* 加入我们 */}
            <JoinNow />
            <div className="sticky-box">
                <div className={`ani-box ${isEnter ? 'begin' : ''}`}>
                    <EfVideo startPlay={startPlay} className="video" autoPlay pc="https://websiteoss.ecoflow.com/upload/video/1742815184620/5%E7%A7%92.mp4" />
                    <div className="ani-text">{t('membersdaybanner25_ecopower_pool')}</div>
                    {/* 能量条 */}
                    <Energy />
                    {/* 积分任务 */}
                    <PointsTask
                        handleShowEcoCredits={(type: string) => {
                            introductionRef.current?.changeActive(type);
                        }}
                    />
                </div>
            </div>
            {/* 产品 */}
            {/* <Product /> */}
            {/* 公司简介 */}
            <Introduction ref={introductionRef} />
            {/* 订阅 */}
            <Subscribe entry_position={5} />
            {/* 分享活动 */}
            <Referral />
            <UGC />
            {/* 利益点 */}
            {/* <ActivityPreview /> */}
            <Footer />
        </div>
    );
};

export default TeaserCompoment;
